// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3BS7K","content":"RecentSearches_content__Ielj2"};